import { AlertTriangle } from 'lucide-react';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from './ui/button';

/** Keeps one broken screen (e.g. an unexpected record) from blanking the whole app. */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('UI error', error, info.componentStack);
  }

  componentDidUpdate(prev: { resetKey?: string }) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="mx-auto mt-16 flex max-w-md flex-col items-center gap-3 text-center">
        <AlertTriangle className="size-8 text-overdue" />
        <h2 className="text-lg font-semibold">משהו השתבש בהצגת המסך</h2>
        <p className="text-sm text-muted">שאר המערכת ממשיכה לעבוד. אפשר לחזור לדף הקודם או לרענן.</p>
        <div className="flex gap-2">
          <Button variant="secondary" onClick={() => window.history.back()}>חזרה</Button>
          <Button onClick={() => window.location.reload()}>רענון</Button>
        </div>
      </div>
    );
  }
}
